module.exports = __webpack_public_path__ + "static/media/upItem.c2cc9667.png";